import { render, staticRenderFns } from "./AccumulationPaymentDeductMain.vue?vue&type=template&id=6241e423&"
import script from "./AccumulationPaymentDeductMain.vue?vue&type=script&lang=ts&"
export * from "./AccumulationPaymentDeductMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports